class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const form = this.querySelector('form');
    if (form) form.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer) {
      const collectionEl = gridContainer.querySelector('.collection');
      if (collectionEl) collectionEl.classList.add('loading');
    }
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.applySectionHtml(html, event);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.applySectionHtml(html, event);
  }

  static applySectionHtml(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    if (parsedHTML.getElementById('ProductGridContainer')) {
      FacetFiltersForm.renderProductGridContainer(html);
    }

    if (parsedHTML.getElementById('FacetFiltersForm') || parsedHTML.getElementById('FacetFiltersFormMobile')) {
      FacetFiltersForm.renderFilters(html, event);
    }

    if (parsedHTML.getElementById('ProductCount')) {
      FacetFiltersForm.renderProductCount(html);
    }

    if (parsedHTML.getElementById('FacetFiltersOpenMobile')) {
      FacetFiltersForm.renderMobileFilterTrigger(html);
    }
  }

  static renderProductGridContainer(html) {
    const destination = document.getElementById('ProductGridContainer');
    const source = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    if (!destination || !source) return;
    destination.innerHTML = source.innerHTML;
  }

  static renderProductCount(html) {
    const source = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    if (!source) return;
    const count = source.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const containerMobile = document.getElementById('ProductCountMobile');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.classList.remove('loading');
    }
    if (containerMobile) {
      containerMobile.innerHTML = `<span>${count}</span>`;
    }
  }

  static renderMobileFilterTrigger(html) {
    const source = new DOMParser().parseFromString(html, 'text/html').getElementById('FacetFiltersOpenMobile');
    const destination = document.getElementById('FacetFiltersOpenMobile');
    if (!source || !destination) return;
    destination.innerHTML = source.innerHTML;
    destination.className = source.className;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelectorAll(`.js-filter[data-index="${element.dataset.index}"]`).forEach((target) => {
        target.innerHTML = element.innerHTML;
      });
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event && event.target) {
      const targetFilter = event.target.closest('.js-filter');
      if (targetFilter) FacetFiltersForm.renderCounts(countsToRender, targetFilter);
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const destination = document.querySelector(selector);
      if (!activeFacetsElement || !destination) return;
      destination.innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const destination = document.querySelector(selector);
      if (!destination) return;
      destination.innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const menuDrawer = mobileForm && mobileForm.closest('menu-drawer');
    if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
      menuDrawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const sections = [];
    const productGrid = document.getElementById('product-grid');
    if (productGrid && productGrid.dataset.id) {
      sections.push({ section: productGrid.dataset.id });
    }
    const sidebar = document.getElementById('CollectionSidebar');
    if (sidebar && sidebar.dataset.sectionId) {
      sections.push({ section: sidebar.dataset.sectionId });
    }
    return sections;
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.minThumb = this.querySelector('[data-price-thumb="min"]');
    this.maxThumb = this.querySelector('[data-price-thumb="max"]');
    this.minInput = this.querySelector('[data-price-input="min"]');
    this.maxInput = this.querySelector('[data-price-input="max"]');
    this.minDisplay = this.querySelector('[data-price-display="min"]');
    this.maxDisplay = this.querySelector('[data-price-display="max"]');
    this.fill = this.querySelector('[data-price-fill]');

    if (!this.minInput || !this.maxInput) {
      const fallback = Array.from(this.querySelectorAll('input:not([type="range"])'));
      this.minInput = fallback[0];
      this.maxInput = fallback[1];
    }

    if (!this.minInput || !this.maxInput) return;

    this.rangeMax = Number(this.dataset.rangeMax || this.maxInput.getAttribute('max') || this.maxThumb?.getAttribute('max') || 0);

    this.onThumbInput = this.onThumbInput.bind(this);
    this.onNumberChange = this.onNumberChange.bind(this);

    if (this.minThumb && this.maxThumb) {
      this.minThumb.addEventListener('input', this.onThumbInput);
      this.maxThumb.addEventListener('input', this.onThumbInput);
    }

    this.minInput.addEventListener('change', this.onNumberChange);
    this.maxInput.addEventListener('change', this.onNumberChange);
    if (this.minInput.type !== 'hidden') {
      this.minInput.addEventListener('input', this.onNumberChange);
      this.maxInput.addEventListener('input', this.onNumberChange);
    }

    this.syncFromInputs();
  }

  parseValue(value, fallback) {
    const num = Number(value);
    return Number.isFinite(num) ? num : fallback;
  }

  getBounds() {
    const min = this.parseValue(this.minInput.value, 0);
    const maxRaw = this.maxInput.value;
    const max = maxRaw === '' || maxRaw == null
      ? this.rangeMax
      : this.parseValue(maxRaw, this.rangeMax);
    return {
      min: Math.min(Math.max(0, min), this.rangeMax),
      max: Math.min(Math.max(0, max), this.rangeMax)
    };
  }

  setDisplays(min, max) {
    if (this.minDisplay) this.minDisplay.textContent = String(min);
    if (this.maxDisplay) this.maxDisplay.textContent = String(max);
  }

  updateFill(min, max) {
    const slider = this.querySelector('[data-price-slider]');
    if (!slider || !this.rangeMax) return;
    const start = (min / this.rangeMax) * 100;
    const end = (max / this.rangeMax) * 100;
    slider.style.setProperty('--range-min', `${start}%`);
    slider.style.setProperty('--range-max', `${end}%`);
  }

  syncThumbs(min, max) {
    if (!this.minThumb || !this.maxThumb) return;
    this.minThumb.value = String(min);
    this.maxThumb.value = String(max);
    this.minThumb.setAttribute('aria-valuenow', String(min));
    this.maxThumb.setAttribute('aria-valuenow', String(max));
  }

  syncFromInputs() {
    let { min, max } = this.getBounds();
    if (min > max) {
      const swap = min;
      min = max;
      max = swap;
      this.minInput.value = min === 0 ? '' : String(min);
      this.maxInput.value = max >= this.rangeMax ? '' : String(max);
    }
    this.syncThumbs(min, max);
    this.setDisplays(min, max);
    this.updateFill(min, max);
  }

  onThumbInput(event) {
    if (!this.minThumb || !this.maxThumb) return;
    let min = this.parseValue(this.minThumb.value, 0);
    let max = this.parseValue(this.maxThumb.value, this.rangeMax);

    if (event.currentTarget === this.minThumb) {
      this.minThumb.style.zIndex = '8';
      this.maxThumb.style.zIndex = '7';
      if (min > max) {
        min = max;
        this.minThumb.value = String(min);
      }
    } else {
      this.maxThumb.style.zIndex = '8';
      this.minThumb.style.zIndex = '7';
      if (max < min) {
        max = min;
        this.maxThumb.value = String(max);
      }
    }

    this.minInput.value = min <= 0 ? '' : String(min);
    this.maxInput.value = max >= this.rangeMax ? '' : String(max);
    this.setDisplays(min, max);
    this.updateFill(min, max);
  }

  onNumberChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.syncFromInputs();
  }

  adjustToValidValues(input) {
    if (input.value === '') return;
    const value = Number(input.value);
    if (!Number.isFinite(value)) return;
    const min = Number(input.getAttribute('min') || 0);
    const max = Number(input.getAttribute('max') || this.rangeMax);
    if (value < min) input.value = String(min);
    if (value > max) input.value = String(max);
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const link = this.querySelector('a');
    if (!link) return;
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);
